<script setup lang="ts">
import { useProgressStore } from '@/stores/progress.store';

const progress = useProgressStore();
</script>

<template>
  <div class="d-flex justify-content-evenly h-100 align-middle">
    <template v-for="(state, index) in Array.from(progress.states.keys())" :key="state">
      <div class="step d-flex flex-column justify-content-center">
        <h4
          :class="{
            active: progress.states.get(state) === progress.currentState,
          }"
        >
          {{ state }}
        </h4>
      </div>
      <div v-if="index != Array.from(progress.states.keys()).length - 1" class="step d-flex flex-column justify-content-center">
        <h4 class="delimiter">></h4>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.step {
  h4 {
    font-size: 1em;
    margin: 0;
    color: #8a8a8a;
  }
  .delimiter {
    color: #c8c8c8;
  }
  .active {
    color: #71c7a7;
  }
}
</style>
